import { useState } from 'react';

const faqItems = [
  {
    q: '黑料视频是什么平台？',
    a: '黑料视频是一个24小时不间断更新的黑料社区平台，由体内精69xxxxx黑料社运营。我们汇集全网最新爆料视频、内幕追踪与社区热议话题，所有内容均可免费在线观看，无需注册。',
  },
  {
    q: '网站内容多久更新一次？',
    a: '黑料视频保持24小时滚动更新机制，确保最新爆料视频在第一时间上线。我们的编辑团队与社区用户共同维护内容时效性，通常每隔数小时即有新内容发布。',
  },
  {
    q: '如何向黑料社投稿爆料？',
    a: '您可以通过上方"联系我们"区域的邮箱地址发送爆料内容。我们承诺对投稿人信息严格保密，经核实有价值的爆料将在平台发布并标注来源。',
  },
  {
    q: '观看视频需要付费或注册吗？',
    a: '不需要。黑料视频所有内容完全免费，无需注册账号即可直接在线观看。我们致力于打造开放、自由的社区环境，让每个人都能便捷获取信息。',
  },
  {
    q: '如何关注特定话题的最新动态？',
    a: '您可以在下方"话题广场"区域浏览当前热门话题标签，也可以通过"主题索引"找到感兴趣的专题合集。我们建议定期访问本站首页以获取24小时最新更新。',
  },
];

export default function FAQSection() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-[960px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-extrabold text-foreground-900">
            常见问答
          </h2>
          <p className="text-sm md:text-base text-foreground-600 mt-2">
            关于黑料视频平台的常见问题解答
          </p>
        </div>

        <div className="space-y-3">
          {faqItems.map((item, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-xl border border-background-200/70 overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-background-100/50 transition-colors"
                onClick={() => setOpenIdx(openIdx === i ? null : i)}
              >
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 pr-4">
                  {item.q}
                </h3>
                <span className="w-6 h-6 flex items-center justify-center shrink-0 text-foreground-500">
                  <i className={`ri-${openIdx === i ? 'subtract' : 'add'}-line text-lg transition-transform`} />
                </span>
              </button>
              {openIdx === i && (
                <div className="px-5 pb-4">
                  <p className="text-sm text-foreground-600 leading-relaxed">{item.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}